var api = "https://api.qingcigame.com/web";

var index = '';
var _index = $('.index');

var initialSlide = 0; //设置默认索引为0
var change = true;
var num = 0; //当前播放歌曲的下标
var music = new Howl({
    src: ["//download4.qcplay.com/qcgame-admin/wNiFjUOf9mrfu6Tq2D9vjxbwLcGcPSTU80sZJa5w.mp3"],
    autoplay: true,
    loop: true,
    onplay: function() {
        $('.h-music-box').addClass('music-on'); //开始播放样式
    },
});
var musicCount = 0;

var obj = {
    index: function() {
        function getRequest() {
            var query = window.location.search;
            if (query.indexOf("?") != -1) {
                var str = query.substring(1);
                var strs = str.split("=");
                if (strs[1] == 1) {
                    initialSlide = 1;
                } else if (strs[1] == 2) {
                    initialSlide = 2;
                } else if (strs[1] == 3) {
                    initialSlide = 3;
                } else if (strs[1] == 4) {
                    initialSlide = 4;
                } else if (strs[1] == 5) {
                    initialSlide = 5;
                } else if (strs[1] == 6) {
                    initialSlide = 6;
                }
            }
        };
        getRequest(); //二级页面导航栏跳转
        this.preloading(); // 预加载
        this.onAdaptive();
        this.indexAjax(); // 首页数据
        this.jqslideTxtBox(); // 游戏咨询信息切换
        this.indexBind(); // 首页按钮
        this.hiddenNav();
        this.newsBanner(); //新闻轮播
        this.musicPlay(); //音乐播放
        // this.countNum(); //阿里云埋点
    },
    // 新闻列表
    newsList: function() {
        this.pageShow();
        // var urls = api + "/article"; // 第一页
        var urls = "https://api.qingcigame.com/web/article"; // 第一页
        this.hiddenNav(); // 头部隐藏导航
        this.newsZxList(urls); // 新闻最新列表
        this.newsTabPage(); // 新闻导航切换
        this.indexBind(); // 首页按钮
        this.musicPlay(); //音乐播放
    },
    // 新闻详情
    newsDetails: function() {
        this.pageShow();
        this.hiddenNav(); // 头部隐藏导航
        this.newsInfo(); // 新闻详情
        this.indexBind(); // 首页按钮
        this.musicPlay(); //音乐播放
    },
    // 视听回廊
    galleryList: function() {
        this.pageShow();
        this.hiddenNav(); // 头部隐藏导航
        this.jqslideTxtBox(); // 游戏咨询信息切换
        this.videoSwiper(); //视频轮播
        this.wookmarkBind(); // 瀑布流图片
        // this.galleryBind(); //按钮事件
        this.galleryAjax(); //视听回廊接口
    },
    // 首页提示
    indexBind: function() {
        // 百度品专taptap特殊处理
        var query = window.location.search;
        if (query.indexOf('type=bdpz') != -1) {
            $('.taptap-btn').remove();
            $('.taptap-gz-btn').remove();
            $('.link-box , .friend-box').addClass('bdpz')
        }

        $('.monitor-btn').on('click', function() {
            var mon_btn = $(this).attr('data-event');
            obj.countNum(mon_btn);
        })

        // 安卓下载链接暂未开放
        // $('.and-btn').click(function(event) {
        //     layer.msg("敬请期待", { time: 2000 });
        // });

        // 官方充值链接暂未开放
        $('.top-up-btn').click(function(event) {
            layer.msg("敬请期待！", { time: 2000 });
        });

        // 视频播放
        var Media = document.getElementById('media-play');
        $('.video-btn').click(function() {
            music.pause();
            musicCount = 1;
            $('.h-music-box').addClass('ani-pause');

            var _this = $(this);
            var data = _this.attr('data');
            $('.play-popup').fadeIn().find('video').attr('src', data);
            Media.play();
        });

        // 关闭视频
        $('.video-pop').click(function(event) {
            $('.popup').fadeOut().find('video').attr('src', '');
            Media.pause();

            music.play();
            $('.h-music-box').removeClass('ani-pause'); //去除暂时播放样式
            $('.h-music-box').addClass('music-on'); //开始播放样式
            musicCount = 0;
        });

        // // 关闭弹窗
        // $('.popup').on('click', function(event) {
        //     $('.popup').fadeOut();
        // });

        // 关闭弹窗
        $('.popup').on('click', '.close-btn', function(event) {
            $('.popup').fadeOut();
        });

        // 关闭弹窗
        $('.popup').on('click', function(event) {
            $('.popup').fadeOut();
        });


        // 打开悬浮窗
        $('.float-nav .click-btn').click(function(event) {
            $('.float-nav').hasClass('nav-show') ? $('.float-nav').removeClass('nav-show') : $('.float-nav').addClass('nav-show');
            // $('.float-nav').addClass('nav-show');
        });

        // 客服浮标
        $('.kefu-code .click-btn').click(function(event) {
            $('.kefu-code').hasClass('kefu-hide') ? $('.kefu-code').removeClass('kefu-hide') : $('.kefu-code').addClass('kefu-hide');
        });

        // 关闭悬浮窗
        $('.nav-bg .back-btn').click(function(event) {
            $('.float-nav').removeClass('nav-show');
        });

        // 适龄弹窗
        $('.year-btn').click(function(event) {
            $('.year_pop').fadeIn();
        });

        // 企业微信弹窗
        $('.enterprise-wechat-btn').click(function(event) {
            $('.enterprise-wechat-popup').fadeIn();
        });

        // 微信关注弹窗
        $('.wx-gz-btn, .weixin-btn').click(function(event) {
            $('.float-nav').removeClass('nav-show');
            $('.wx-gz-popup').fadeIn();
        });

        // 微博关注弹窗
        $('.wb-gz-btn').click(function(event) {
            $('.float-nav').removeClass('nav-show');
            $('.wb-gz-popup').fadeIn();
        });

        // 抖音关注弹窗
        $('.dy-gz-btn').click(function(event) {
            $('.float-nav').removeClass('nav-show');
            $('.dy-gz-popup').fadeIn();
        });

        // taptap关注弹窗
        $('.taptap-gz-btn').click(function(event) {
            $('.float-nav').removeClass('nav-show');
            $('.tt-gz-popup').fadeIn();
        });

        // qq群关注弹窗
        $('.qq-gz-btn').click(function(event) {
            $('.float-nav').removeClass('nav-show');
            $('.qq-gz-popup').fadeIn();
        });

        // 小红书关注弹窗
        $('.xhs-gz-btn').click(function(event) {
            $('.float-nav').removeClass('nav-show');
            $('.xhs-gz-popup').fadeIn();
        });

        $('.swiper-container-video').on('click', '.swiper-slide', function(event) {
            var data = $(this).attr('data');
            $('.popup-wrap').fadeIn().find('iframe').attr('src', data);
        });

        $('.close-btn').click(function(event) {
            $('.popup').fadeOut().find('iframe').attr('src', '');
        });

        $('.download-btn').click(function(event) {
            var className = $(this).attr('class');
            var game_id = 74;
            var query = window.location.search;
            // 百度品专 专属下载地址
            if (query.indexOf('type=bdpz') != -1) {
                if (className.indexOf('app-btn') !== -1) {
                    // ios
                    location.href = "https://ad.qingcigame.com/v1/ad-click?game_id=74&os=iOS&company=qc&channel=kol&tag=1115251&optimizer_id=19&redirct=https://apps.apple.com/cn/app/%E9%AD%94%E5%8D%A1%E5%B0%91%E5%A5%B3%E6%A8%B1-%E5%9B%9E%E5%BF%86%E9%92%A5%E5%8C%99/id6450409747";
                } else {
                    // 安卓
                    location.href = "https://download4.qcplay.com/apk-v2/qc-kol-1111149.apk";
                }
            } else {
                $.ajax({
                    type: "get",
                    url: 'https://api.qingcigame.com/get_url?game_id=' + game_id + '',
                    dataType: 'json',
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function(json) {
                        // 微信
                        var ua = navigator.userAgent.toLowerCase();
                        if (ua.match(/MicroMessenger/i) == "micromessenger") {
                            $('.download_wrap').fadeIn();
                            return
                        };

                        if (className.indexOf('app-btn') !== -1) {
                            // ios
                            location.href = json.data.ios_down_url;
                        } else {
                            // 安卓
                            location.href = json.data.android_down_url;
                        }

                    }
                });
            }
        });
        // 关闭下载提示
        $('.download_wrap').on('click', function() {
            $('.download_wrap').fadeOut();
        });

        // 关闭安卓下载提示
        $('.android_wrap').on('click', function() {
            $('.android_wrap').fadeOut();
        });

        // 仙剑音画【壁纸】
        $(".wallpaper-box .item img").on('click', function() {
            var _this = $(this);
            var img_url = _this.attr('src');
            $('.wallpaper-wrap').fadeIn();
            $('.wallpaper-wrap img').attr("src", img_url);
        });

        $('.wallpaper-wrap').on('click', '.close-btn', function(event) {
            $('.popup').fadeOut();
            setTimeout(() => {
                $('.wallpaper-wrap img').attr("src", '');
            }, 300)
        });

    },
    newsBanner: function() {
        // index = layer.load(2, { shade: [0.1, '#fff'] });
        $.ajax({
            url: "https://api.qingcigame.com/web/news/info",
            type: "GET",
            data: {
                game_id: 74
            },
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                if (json.code == 200) {
                    var article = json.data.article;
                    $.each(article.game_information, function(index, values) {
                        var gameInfoIndex = `<div class="swiper-slide">
                        <a  href="${values.jump_url}">
                        <img src="${values.image}">
                        <span></span>
                        </a>
                        </div>`;
                        $('.swiper-container-news .swiper-wrapper').append(gameInfoIndex);
                    });


                } else {
                    layer.msg("服务器请求失败", { time: 2000 });
                }

            },
            error: function() {
                layer.msg("服务器请求失败", { time: 2000 });
            },
            complete: function() {
                layer.close(index);
            }
        })
    },
    showSwiper: function() {
        var showSwiper = new Swiper('.swiper-container-show', {
            loop: true,
            paginationClickable: true,
            grabCursor: true,
            centeredSlides: true,
            slidesPerView: 'auto',
            // noSwiping: true,
            autoplay: 2000,
            spaceBetween: 100,
            autoplayDisableOnInteraction: false,
            navigation: {
                nextEl: '.swiper-button-next2',
                prevEl: '.swiper-button-prev2',
            },
            speed: 500,
            on: {
                init: function(swiper) {
                    swiperAnimate(this);
                    // swiper.stopAutoplay();

                    function Ani(btn, page) {
                        $(btn).on('click', function() {
                            showSwiper.slideTo(page, 500, true);
                            $(this).parent().addClass('select').siblings().removeClass("select")
                        });
                    };

                    function showLink() {
                        for (var i = 4; i >= 0; i--) {
                            Ani('.show-click-box .s' + i, i - 1);
                        };
                    }
                    showLink();

                },
                slideChangeTransitionStart: function(swiper) {
                    // console.log(this.realIndex);
                    $('.show-click-box .s' + (this.realIndex + 1)).parent().addClass('select').siblings().removeClass("select");
                },
            }
        });
    },
    // 图片资源预加载
    preloading: function() {
        if (event.persisted || window.performance && window.performance.navigation.type == 2) {
            window.location.reload();
        }
        //图片预加载
        var queue = new createjs.LoadQueue();
        queue.on("progress", function(e) {
            //加载中的进度
            // if (e.progress * 100 >= 10) {
            //     if (cw < 1300) {
            //         cw = 1300
            //     }
            //     var cw = document.documentElement.clientWidth;
            //     var loadingW = 0;
            //     loadingW = Number((8.22 * (cw / 19.20)).toFixed(2));
            //     var OInner = $('.process-inner');
            //     var OPercent = $('#percent');
            //     var timer2;
            //     var w0 = 0;
            //     timer2 = setInterval(function() {
            //         OInner.width(w0 += 2);
            //         OPercent.text(parseInt(w0 * 100 / loadingW));
            //         if (parseInt(w0 * 100 / loadingW) >= 100) {
            //             clearInterval(timer2);
            //         }
            //         if (w0 > loadingW) {
            //             clearInterval(timer2);
            //             $('#preloading').fadeOut(300, function() {
            //                 $('#preloading').remove();
            //             });
            //         };
            //     }, 5);
            // };
            if (e.progress * 100 >= 10) {
                // console.log(parseInt(e.progress * 100) + '%');
                $(".process-track .process-inner").width(parseInt(e.progress * 100) + '%');
                $(".process-percent #percent").html(parseInt(e.progress * 100));
            };
        }, this);
        queue.on("complete", function(e) {
            //加载完成执行操作
            var _this = this;
            $('.index').addClass('index-show');
            _this.indexSwiper();
            setTimeout(function() {
                $('#preloading').remove();
            }, 300)
        }, this);
        queue.loadManifest([
            //加载图片，不包括后台的            
            '/official/images/mobile/index_content_bg_01-5fd9165a04.png',
            '/official/images/mobile/main_title-4e0e1745fc.png',
            '/official/images/mobile/year_btn-04a474ade4.png',
            '/official/images/mobile/year_btn-04a474ade4.png',
            '/official/images/mobile/header_bg-771e00deac.png',
            '/official/images/mobile/charity_btn-41d61f8b01.png',
            // '/official/images/mobile/download_btn.png',
            '/official/images/mobile/app_btn-7ee0d7ed7d.png',
            '/official/images/mobile/and_btn-15963545c1.png',
            '/official/images/mobile/taptap_btn-658cd292c8.png',
            '/official/images/mobile/weibo_btn-11529ceb1b.png',
            '/official/images/mobile/tieba_btn-c43aeda03f.png',
            '/official/images/mobile/arrow_btn-8446befa51.png',
            '/official/images/mobile/nav_bg-d273f928bb.png',
        ]);
    },
    onAdaptive: function() {
        const width = $(window).width();
        const height = $(window).height();
        const proportion = width / height;
        proportion < 0.568 ? _index.addClass('adaptive-0') : _index.removeClass('adaptive-0');
        proportion >= 0.568 && proportion < 0.606 ? _index.addClass('adaptive-1') : _index.removeClass('adaptive-1');
        proportion >= 0.606 && proportion < 0.650 ? _index.addClass('adaptive-2') : _index.removeClass('adaptive-2');
        proportion >= 0.650 ? _index.addClass('adaptive-3') : _index.removeClass('adaptive-3');

        if (navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger') {
            $('.link-box').addClass('wx-link-box');
        }
    },
    defaultVideo: function() {
        $(".play-btn").on('click', function() {
            var src = 'https://download4.qcplay.com/file/video_30m.mp4';
            $('.play-btn').fadeIn().attr('data', src);
            $('.popup-wrap').fadeIn().find('iframe').attr('src', $('.play-btn').attr('data')).removeClass('ani-btn');
        })
        $('.popup').on('click', '.close-btn', function(event) {
            $('.popup-wrap').find('iframe').attr('src', '');
        });
    },
    // 首页接口请求
    indexAjax: function() {
        // var index = layer.load(2, { shade: [0.1, '#fff'] });
        var _this = this;
        $.ajax({
            url: api + "/cherry/index",
            type: "GET",
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                if (json.code == 200) {
                    var zonghe = json.data.articleList.zonghe_news; //综合
                    var activity = json.data.articleList.activity_news; //活动
                    var gongyi = json.data.articleList.gongyi; //公益
                    var zuixin = json.data.articleList.zuixin; //最新
                    var mengxin = json.data.articleList.mengxin; //萌新
                    var jinjie = json.data.articleList.jinjie; //进阶

                    var music = json.data.articleList.music; //音乐
                    var video = json.data.articleList.video; //视频
                    var wallpaper = json.data.articleList.picture; //壁纸

                    var ulr = json.data.articleList.ulr;
                    var spec = json.data.articleList.spec;

                    // var taptap_url = 'https://l.tapdb.net/hkT7pBAG?channel=rep-rep_mfrj9temidf';
                    // var tieba_url = 'https://tieba.baidu.com/f?ie=utf-8&kw=%E6%96%B0%E4%BB%99%E5%89%91%E5%A5%87%E4%BE%A0%E4%BC%A0%E4%B9%8B%E6%8C%A5%E5%89%91%E9%97%AE%E6%83%85&fr=search';
                    // var qq_url = 'https://static2.qcplay.com/qq_group_jump/index.html?game_id=69';
                    var bilibili_url = 'https://www.biligame.com/detail/?id=107034&sourceFrom=2000040011&spm_id_from=333.337.0.0';
                    var weibo_url = 'https://weibo.com/p/10080825f5401093265d11bba871ebf18e235f/super_index';
                    var ios_url = 'https://apps.apple.com/cn/app/%E6%96%B0%E4%BB%99%E5%89%91%E5%A5%87%E4%BE%A0%E4%BC%A0%E4%B9%8B%E6%8C%A5%E5%89%91%E9%97%AE%E6%83%85/id6447745041';
                    var weibo_gz_url = 'https://weibo.com/u/7607833915';
                    // var qq_url = 'https://static2.qcplay.com/qq_group_jump/index.html?game_id=74';
                    var taptap_url = 'https://www.taptap.cn/app/378363';

                    $('.bilibili-btn').attr('href', bilibili_url);
                    $('.weibo-btn').attr('href', weibo_url);
                    // $('.app-btn').attr('href', ios_url);
                    $('.weibo-gz-btn').attr('href', weibo_gz_url);
                    // $('.qq-btn').attr('href', qq_url);
                    $('.taptap-btn').attr('href', taptap_url);

                    // 【活动资讯】最新
                    $.each(zuixin, function(index, values) {
                        var zuixinHtml = `<li>
                            <a href="news-details-mobile.html?id=${values.id}">
                                <h2>${values.article_title}</h2>
                                <span>${values.created_at}</span>
                            </a>
                        </li>`;;
                        $('.zuixin').append(zuixinHtml);
                    });

                    // 【活动资讯】公告
                    $.each(gongyi, function(index, values) {
                        var gonggaoHtml = `<li>
                            <a href="news-details-mobile.html?id=${values.id}">
                                <h2>${values.article_title}</h2>
                                <span>${values.created_at}</span>
                            </a>
                        </li>`;;
                        $('.gonggao').append(gonggaoHtml);
                    });

                    // 【活动资讯】活动
                    $.each(activity, function(index, values) {
                        var activityHtml = `<li>
                            <a href="news-details-mobile.html?id=${values.id}">
                                <h2>${values.article_title}</h2>
                                <span>${values.created_at}</span>
                            </a>
                        </li>`;
                        $('.activity').append(activityHtml);
                    });
                    _this.showSwiper(); //套装展示轮播
                    _this.Textlength(28, 23);
                } else {
                    layer.msg("服务器请求失败", { time: 2000 });
                }

            },
            error: function() {
                layer.msg("服务器请求失败", { time: 2000 });
            },
            complete: function() {
                layer.close(index);
            }
        })

        // $.ajax({
        //     url: "//api.qingcigame.com/channel/join/group?game_id=74",
        //     type: "POST",
        //     xhrFields: {
        //         withCredentials: true
        //     },
        //     success: function(json) {
        //         if (json.code == 200) {
        //             $('.qq-btn').attr('href', json.data.channel_url.qq_url);
        //         }
        //     },
        //     error: function() {
        //         layer.msg("服务器请求失败", { time: 2000 });
        //     },
        //     complete: function() {
        //         layer.close(index);
        //     }
        // })

    },
    // 首页轮播
    indexSwiper: function() {
        function pageSwiper() {
            var mySwiper = new Swiper('.swiper-container', {
                pagination: '.swiper-pagination',
                direction: 'vertical',
                slidesPerView: 'auto',
                paginationClickable: true,
                spaceBetween: 0,
                mousewheel: true,
                resistanceRatio: 0,
                initialSlide: initialSlide,
                parallax: true,
                on: {
                    init: function() {
                        swiperAnimate(this);

                        function Ani(btn, page) {
                            $(btn).on('click', function() {
                                $('.float-nav').removeClass('nav-show');
                                $('.nav_more').removeClass('change');
                                change = true;
                                mySwiper.slideTo(page, 1000, true);
                            });
                        };

                        function navLink() {
                            for (var i = 6; i >= 0; i--) {
                                Ani('.nav-link-0' + i + ' .link-a', i);
                            };
                        }
                        navLink();

                        var aniLink01 = Ani('.arrow-btn', '1');
                        var aniLink02 = Ani('.arrow-b2', '2');
                        var aniLink03 = Ani('.arrow-b3', '3');
                        var aniLink04 = Ani('.arrow-b4', '4');
                    },
                    slideChangeTransitionEnd: function() {
                        swiperAnimate(this);
                        // mySwiper.activeIndex >= 7 ? $('.rocket').fadeIn() : $('.rocket').fadeOut();
                        // swiperAnimate(this);
                        $('.nav-link').removeClass('on')
                        $('.nav-link-0' + this.activeIndex + '').addClass('on');
                    },
                    // transitionStart: function() {
                    //     swiperAnimate(this);
                    // },
                },
            });
            $('body').on('click', '.rocket', function(event) {
                var _this = $(this);
                _this.addClass('rocket-ani')
                mySwiper.slideTo(0, 1000, true);
                setTimeout(function() { _this.fadeOut() }, 1000);
                setTimeout(function() { _this.removeClass('rocket-ani') }, 1500);
            });
        }
        pageSwiper();

        function newsSwiper() {
            var swiperNews = new Swiper('.swiper-container-news', {
                loop: true,
                paginationClickable: true,
                pagination: {
                    el: '.swiper-pagination2',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                slidesPerView: 'auto',
                autoplay: true,
                autoplay: 2000,
            });
        }
        newsSwiper();

        function featureSwiper() {
            var charitySwiper = new Swiper('.swiper-container-feature', {
                loop: true,
                direction: 'horizontal',
                paginationClickable: true,
                pagination: {
                    el: '.swiper-pagination4',
                    clickable: true,
                },
                autoplayDisableOnInteraction: false,
                navigation: {
                    nextEl: '.swiper-button-next3',
                    prevEl: '.swiper-button-prev3',
                },
                initialSlide: 5,
                speed: 500,
                on: {
                    slideNextTransitionStart: function() {
                        $('.xk-wrap .hand').removeClass('h-next').addClass('h-prev')
                    },
                    slidePrevTransitionStart: function() {
                        $('.xk-wrap .hand').removeClass('h-prev').addClass('h-next')
                    }
                },
            });
            $('.xk-wrap .hand').on('animationend', function() {
                $(this).removeClass('h-next');
                $(this).removeClass('h-prev');
            })
        }
        featureSwiper();
    },
    // 视频轮播
    videoSwiper: function() {
        function videoSwiper() {
            var videoSwiper = new Swiper('.swiper-container-video', {
                loop: true,
                // spaceBetween: 5.66,
                loopedSlides: 7,
                slidesPerView: 3,
                observer: true, //当改变swiper的样式（例如隐藏/显示）或者修改swiper的子元素时，自动初始化swiper
                speed: 300,
                // nextButton: '.swiper-button-next2',
                // prevButton: '.swiper-button-prev2',
                onInit: function(swiper) {
                    swiper.slideTo(pageIndex === 1 ? imgIndex : videoIndex, 0, true);

                    // 当轮播点击的时候做的操作
                    // $(".img-box img").on('click', function(event) {
                    //     var _this = $(this);
                    //     var dataSrc = _this.attr('src');
                    //     // 替换上半部分显示的图的路径
                    //     $('.art img').attr("src", dataSrc);
                    // })

                    // 开放视频
                    // $(".videos-box img").on('click', function(event) {
                    //     var data = $(this).parent().parent().attr('data');
                    //     var _this = $(this);
                    //     var dataSrc = _this.attr('src');
                    //     // 替换上半部分显示的图的路径以及播放路径
                    //     $('.videos img').attr("src", dataSrc);
                    //     $('.videos a').attr("data", data);
                    // })

                    // 暂未开放视频
                    // $(".videos-box img").on('click', function(event) {
                    //     layer.msg("Coming soon. Please stay tuned!", { time: 2000 });
                    // })
                },
                onSlideChangeEnd: function(swiper) {
                    swiperAnimate(swiper);
                },
                onTouchEnd: function(swiper) {
                    swiperAnimate(swiper);
                },

            });
        };
        videoSwiper();
    },
    wookmarkBind: function() {
        var articleList = [
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/big/1.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/2.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/3.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/4.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/5.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/big/3.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/6.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/7.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/big/4.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/8.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/9.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/10.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/11.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/12.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/big/7.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/13.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/big/8.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/big/9.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/14.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/15.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/big/10.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/16.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/17.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/18.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/19.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/20.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/21.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/22.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/23.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/24.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/25.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/26.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/27.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/28.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/29.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/30.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/31.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/32.jpg' },
        ];
        $.each(articleList, function(index, values) {
            var dtHtml = '<li class="grid-item">' +
                '<img src=' + values.thumbnail + '>' +
                '</li>';
            $('#tiles').append(dtHtml);
        });

        $('#tiles').imagesLoaded(function() {
            var options = {
                itemWidth: 100,
                autoResize: true,
                container: $('#tiles'),
                offset: 15,
                outerOffset: 0,
                flexibleWidth: 120
            };
            var handler = $('#tiles li');
            handler.wookmark(options);
        });

        setTimeout(() => {
            $('.htmleaf-box').addClass('htmleaf-box-show');
        }, 1000);
    },
    // 游戏咨询&游戏攻略信息切换
    jqslideTxtBox: function() {
        jQuery(".slideTxtBox").slide({ effect: "left", trigger: "click", easing: "swing" });
        jQuery(".slideTxtBox-02").slide({ effect: "left", trigger: "click", easing: "swing" });
        jQuery(".gallery-box .main").slide({ effect: "left", trigger: "click", easing: "swing" });
    },
    // 视听回廊按钮事件
    galleryBind: function() {
        // 三个页面切换 初始化
        let page_id = this.getQueryVariable('page_id');
        $('.gallery-box .li-0' + page_id + '').addClass('on').siblings().removeClass('on');
        var btn = $('.gallery-box .li-0' + page_id + '');
        setTimeout(function() {
            btn.click();
        }, 300);

        // 视听回廊切换
        $('.gallery-box .hd li').click(function() {
            Media.pause();
            myMusic.pause();
            $('.record-player , .h-music-box').addClass('ani-pause'); //添加暂时播放样式
            $('.record-rocker').addClass('rocker-pause'); //添加暂时播放样式
            $('.music-box .play-box .play-btn').addClass('ani-pause'); //添加暂时播放样式
        });

        var Media = document.getElementById('media-play');
        // 媒体视频播放
        $('.video-btn').on('click', function(event) {
            var _this = $(this);
            $('.thumbnail-img').fadeOut(); //视频展示图
            $('.video-show-box video').fadeIn(); //视频
            $('.video-btn').fadeOut(); //视频按钮
            Media.play(); //播放
        });

        // 视频预览
        $('.swiper-container-video .videos-box').on('click', 'a', function() {
            var _this = $(this).find('img');
            var img_src = _this.attr('src');
            var video_src = _this.attr('data');
            var video_title = _this.attr('title');

            $(this).parent().addClass("on");
            $(this).parent().siblings().removeClass("on");
            $('.thumbnail-img').fadeIn();
            $('.video-show-box video').show();
            $('.video-btn').fadeIn();

            $('.thumbnail-img').find('img').attr('src', img_src); //图片填充
            $('.video-show-box').find('video').attr('src', video_src); //视频填充
            $('#videoName').html(video_title); //视频标题填充
            // Media.play(); //播放
        });

        // 歌曲选择按钮
        $('.select-btn').click(function(event) {
            $(".music-select-wrap").fadeIn();
        });

        // 点击背景关闭弹窗
        $('.music-select-wrap').click(function(event) {
            if ($(event.target)[0] == $(this)[0]) {
                $(this).fadeOut();
            }
        });

        // // 视听回廊【音乐】
        // //音乐播放按钮
        const myMusic = document.getElementById("myMusic");

        // 顶部music按钮点击时关闭视频
        $('.h-music-box').click(function(event) {
            Media.pause();
        });
    },
    // 视听回廊接口
    galleryAjax: function() {
        var _this = this;
        music.pause();
        $.ajax({
            url: api + "/cherry/index",
            type: "GET",
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                if (json.code == 200) {
                    var video = json.data.articleList.video; //视频

                    // 【游戏视频】
                    if (video.length !== 0) {
                        $(".video-show-box .thumbnail-img img").attr("src", video[0].move_thumbnail);
                        $(".video-show-box video").attr("src", video[0].video_link);
                        $(".content-box #videoName").html(video[0].article_title);
                        $(".content-box .content").html(video[0].article_excerpt);
                    }

                    $('.content-box #videoName').each(function() {
                        if ($(this).text().length > 11) {
                            var str = $(this).text();
                            $(this).text(str.substr(0, 11) + '...');
                        }
                    });

                    $('.content-box .content').each(function() {
                        if ($(this).text().length > 180) {
                            var str = $(this).text();
                            $(this).text(str.substr(0, 180) + '...');
                        }
                    });

                    $.each(video, function(index, values) {
                        var videoHtml = `<div class="swiper-slide videos-box">
                                <a href="javascript:;">
                                    <img src="${values.move_thumbnail}" data="${values.video_link}" title="${values.article_title}" alt="">
                                    <i></i>
                                    <b class="ani-btn"></b>
                                </a>
                            </div>`;
                        $('.swiper-container-video .slideVideoBox').append(videoHtml);
                    })
                    $('.swiper-container-video .slideVideoBox').children(':eq(0)').addClass('on');

                    _this.galleryBind();
                } else {
                    layer.msg("服务器请求失败", { time: 2000 });
                }
            },
            error: function() {
                layer.msg("服务器请求失败", { time: 2000 });
            },
            complete: function() {
                layer.close(index);
            }
        })
    },
    // 内容字体长度超过40，标题字体长度超过25
    Textlength: function(x1, x2) {
        $('.slideTxtBox .bd p').each(function() {
            if ($(this).text().length > x1) {
                var str = $(this).text();
                $(this).text(str.substr(0, x1) + '...');
            }
        });
        $('.slideTxtBox .bd h2').each(function() {
            if ($(this).text().length > x2) {
                var str = $(this).text();
                $(this).text(str.substr(0, x2) + '...');
            }
        });
    },
    // 隐藏导航
    hiddenNav: function() {
        // 隐藏导航
        $('.navBox').on('click', '.nav_more', function() {
            if (change == true) {
                $('.nav_more').addClass('change');
                $('.float-nav').addClass('nav-show');
                $('.nav-popup').addClass('nav-popup-show');
                change = false;
            } else {
                $('.nav_more').removeClass('change');
                $('.float-nav').removeClass('nav-show');
                $('.nav-popup').removeClass('nav-popup-show');
                change = true;
            }
            $('.screen-popup').fadeOut();
            $('.bottom-nav li').removeClass('on');
        });

        $('body').on('click', '.go-story', function(event) {
            $('.nav_more').removeClass('change');
            $('.nav-popup').removeClass('nav-popup-show');
            change = true;
        });
    },
    // 获取当前hash的具体参数
    getQueryVariable: function(variable) {
        var query = window.location.href.split('?')[1];
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == variable) { return pair[1]; }
        }
        return (false);
    },
    // 最新、综合、活动跳转
    newsTabPage: function() {
        $('.all-list').on('click', 'li', function(event) {
            var cate_id = $(this).attr('cate-id');
            window.location.href = window.location.href.split("?")[0] + '?cate_id=' + cate_id + '&page=1'
        });
    },
    // 新闻列表接口
    newsZxList: function(urls) {
        const params = obj.analysisParams(window.location.href);
        var cate_id, page, current, index;
        current = window.location.href.split("?")[0];
        cate_id = params.cate_id;
        page = params.page;

        index = layer.load(2, { shade: [0.1, '#fff'] });
        $('.li-tab-0' + cate_id + '').addClass('on').siblings().removeClass('on');

        function newsAjax(urls) {
            $.ajax({
                url: urls,
                type: "GET",
                data: {
                    // cate_id 最新-综合-活动
                    // page    1...
                    game_id: 74,
                    cate_id: cate_id,
                    page: page,
                },
                xhrFields: {
                    withCredentials: true
                },
                success: function(json) {
                    if (json.code == 200) {
                        var current_page = json.data.articleList.current_page; // 当前页数
                        var last_page = json.data.articleList.last_page; // 总共页数
                        var next_page_url = json.data.articleList.next_page_url; // 后一页
                        var _data = json.data.articleList.data;

                        if (_data.length == 0) {
                            $('.list-wrap').addClass('list-null');
                        } else {
                            $('.list-wrap').removeClass('list-null');
                            // 渲染列表
                            $.each(json.data.articleList.data, function(index, values) {
                                var dtHtml = `<li>
                                        <a title="${values.article_title}" href="news-details-mobile.html?id=${values.id}">
                                            <img src=${values.index_move_img}>
                                            <div class="info-box">
                                            <h2>${values.article_title}</h2>
                                            <span>${values.created_at}</span>
                                            <b></b>
                                            </div>
                                        </a>
                                    </li>`;
                                $('.list-wrap ul').append(dtHtml);
                            });

                            $('.list-wrap li h2').each(function() {
                                if ($(this).text().length > 32) {
                                    var str = $(this).text();
                                    $(this).text(str.substr(0, 20) + '...');
                                }
                            });

                            $('.current_page').html(current_page); // 当前页数
                            $('.last_page').html(last_page); // 总共页数
                            if (next_page_url === null) { // 下一页
                                $('.more-btn a').attr('data', '').html('没有更多了'); // 没有最后一页
                            } else {
                                page++
                                $('.more-btn a').attr('data', next_page_url.split("web")[1]);
                            }
                        }
                    } else {
                        layer.msg("服务器请求失败", { time: 2000 });
                    }

                },
                error: function() {
                    layer.msg("服务器请求失败", { time: 2000 });
                },
                complete: function() {
                    layer.close(index);
                }
            })
        }
        newsAjax(urls);
        $('.more-btn').on('click', 'a', function(event) {
            var _this = $(this);
            if (_this.attr('data') == '') {
                layer.msg("没有更多了", { time: 2000 });
            } else {
                index = layer.load(2, { shade: [0.1, '#fff'] });
                setTimeout(function() {
                    urls = api + _this.attr('data');
                    newsAjax(urls);
                }, 100)
            }
        });
        for (var i = $('.link-box-02 div a').length; i >= 1; i--) {
            if (cate_id == i) $('.link-box-02 div a:nth-child(' + i + ')').addClass('on');
        };
    },
    // 新闻详情
    newsInfo: function() {
        var id = window.location.href.split('?id=')[1];
        var index = layer.load(2, { shade: [0.1, '#fff'] });
        $.ajax({
            // url: api + "/article/" + id + "",
            url: "https://api.qingcigame.com/web/article/" + id + "",
            type: "GET",
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {

                if (json.code == 200) {
                    var newsTitle = json.data.list.article_title; // 标题
                    var detailsInfo = json.data.list.article_content; // 内容
                    var origin = json.data.list.article_excerpt; // 作者
                    var created_at = json.data.list.created_at; // 时间
                    $('.news-title h1, .current-title').html(newsTitle);
                    if (detailsInfo !== '') {
                        $('.details-info').append(detailsInfo);
                    } else {
                        // <iframe id="media-play" width="817" height="500" src="" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        $('.details-info').append('<iframe id="media-play" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen width="100%" height="100%" disablepictureinpicture="true" style="background-color:#000" src="' + json.data.list.video_link + '"></iframe>');
                    }

                    // 
                    $('.origin').html(origin);
                    $('.created_at').html(created_at);
                    // 翻页功能
                    obj.pageDown(json.data.last, json.data.next, 'id');

                    $('title').html(newsTitle);
                    $('meta[name="keywords"]').attr('content', json.data.list.article_keywords);
                    $('meta[name="description"]').attr('content', json.data.list.article_excerpt);

                } else {
                    layer.msg("服务器请求失败", { time: 2000 });
                }

            },
            error: function() {
                layer.msg("服务器请求失败", { time: 2000 });
            },
            complete: function() {
                layer.close(index);
            }
        })
    },
    // 翻页功能
    pageDown: function(lastPage, nextPage, cite) {
        var href = window.location.href.split("?")[0] + '?' + cite + '='
        if (lastPage !== '') $('.prev-page').addClass('show').attr('href', href + lastPage.id).attr('title', lastPage.article_title);
        if (nextPage !== '') $('.next-page').addClass('show').attr('href', href + nextPage.id).attr('title', nextPage.article_title);
    },
    // 视频切换
    videoSwitch: function() {
        $('.all-list').on('click', 'li', function(event) {
            $(this).addClass('on').siblings('a').removeClass('on');
            var cate_id = $(this).attr('cate-id');
            window.location.href = window.location.href.split("?")[0] + '?id=' + cate_id
        });
    },
    analysisParams: function(url) {
        const params = {};
        const paramsString = url.split('?')[1];
        if (!paramsString) {
            return params;
        }
        const str = paramsString.split('&');
        for (let idx = 0; idx < str.length; idx++) {
            const values = str[idx].split('=');
            params[values[0]] = values[1];
        }
        return params;
    },
    // 攻略列表接口
    newsIntrList: function(urls) {
        const params = obj.analysisParams(window.location.href);
        var cate_id, page, current, index;
        cate_id = params.cate_id;
        page = params.page;
        current = window.location.href.split("?")[0];

        index = layer.load(2, { shade: [0.1, '#fff'] });
        $('.li-tab-0' + cate_id + '').addClass('on').siblings().removeClass('on');

        function newsAjax(urls) {
            $.ajax({
                // url: api + "/new/list",
                url: "https://api.qingcigame.com/web/article",
                type: "GET",
                data: {
                    // cate_id 最新-综合-活动
                    // page    1...
                    game_id: 69,
                    cate_id: cate_id,
                    page: page,
                },
                xhrFields: {
                    withCredentials: true
                },
                success: function(json) {
                    if (json.code == 200) {
                        var current_page = json.data.articleList.current_page; // 当前页数
                        var last_page = json.data.articleList.last_page; // 总共页数
                        var next_page_url = json.data.articleList.next_page_url; // 后一页
                        var _data = json.data.articleList.data;
                        if (_data.length == 0) {
                            $('.list-wrap').addClass('list-null');
                        } else {
                            $('.list-wrap').removeClass('list-null');
                            // 渲染列表
                            $.each(_data, function(index, values) {
                                var dtHtml = `<li>
                                        <a title="${values.article_title}" href="introduction-details-mobile.html?id=${values.id}">
                                            <h2>${values.article_title}</h2>
                                            <span>${values.created_at}</span>
                                        </a>
                                    </li>`;
                                $('.list-wrap ul').append(dtHtml);
                            });
                            $('.current_page').html(current_page); // 当前页数
                            $('.last_page').html(last_page); // 总共页数
                            if (next_page_url === null) { // 下一页
                                $('.more-btn a').attr('data', '').html('没有更多了'); // 没有最后一页
                            } else {
                                page++
                                $('.more-btn a').attr('data', next_page_url);
                            }
                        }
                    } else {
                        layer.msg("服务器请求失败", { time: 2000 });
                    }

                },
                error: function() {
                    layer.msg("服务器请求失败", { time: 2000 });
                },
                complete: function() {
                    layer.close(index);
                }
            })
        }
        newsAjax(urls);
        $('.more-btn').on('click', 'a', function(event) {
            if ($(this).attr('data') == '') {
                layer.msg("没有更多了", { time: 2000 });
            } else {
                urls = $(this).attr('data');
                newsAjax(urls);
            }
        });

        // 导航变色
        if (cate_id == 1) $('.link-box-03 div a:nth-child(1)').addClass('on');
        if (cate_id == 9) $('.link-box-03 div a:nth-child(2)').addClass('on');
        if (cate_id == 19) $('.link-box-03 div a:nth-child(4)').addClass('on');
    },
    // 获取视频中心视频
    videoCenterAjax: function() {
        var id = window.location.href.split("?id=")[1];
        var index = layer.load(2, { shade: [0.1, '#fff'] });
        $('.li-tab-0' + id + '').addClass('on').siblings().removeClass('on');

        // 全部视频
        $.ajax({
            url: api + "/article?cate_id=" + id + "&limit=0",
            type: "GET",
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                if (json.code == 200) {
                    // 渲染视频数量
                    $.each(json.data.articleList2, function(index, values) {
                        var dtHtml = '<li><a style="text-indent: -12.15rem;" href="video-details.html?id=' + values.id + '">' + values.article_title + '</a></li>';
                        $('.cartoon-list ul').append(dtHtml);
                    });
                    $('.cartoon-list ul li:nth-child(1)').html();
                    var info = $('.cartoon-list ul li:nth-child(1) a').html()
                    var href = $('.cartoon-list ul li:nth-child(1) a').attr('href');
                    $('.synopsis .start').attr('href', href).find('span').html(info);
                    $('.s-title span').html('(第' + parseInt(json.data.articleList2.length) + '話まで連載)');

                } else {
                    layer.msg("服务器请求失败", { time: 2000 });
                }

            },
            error: function() {
                layer.msg("服务器请求失败", { time: 2000 });
            },
            complete: function() {
                layer.close(index);
            }
        })

        for (var i = $('.link-box-04 div a').length; i >= 1; i--) {
            if (id == 1 + '' + i + '') $('.link-box-04 div a:nth-child(' + i + ')').addClass('on');
        };
    },
    // 获取详细视频
    videoDetailsAjax: function() {
        var id = window.location.href.split("?id=")[1];
        var index = layer.load(2, { shade: [0.1, '#fff'] });
        $.ajax({
            url: api + "/article/" + id + "",
            type: "GET",
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {

                if (json.code == 200) {
                    var newsTitle = json.data.list.article_title; // 标题
                    var detailsInfo = json.data.list.article_content; // 内容
                    var origin = json.data.list.origin; // 作者
                    var created_at = json.data.list.created_at; // 时间
                    var video_link = json.data.list.video_link; // 视频
                    $('.news-title, .current-title').html(newsTitle);
                    $('.details-info').append(detailsInfo);
                    $('.origin').html(origin);
                    $('.created_at').html(created_at);
                    $('.details-info iframe').attr('src', video_link);
                    // 翻页功能
                    obj.pageDown(json.data.last, json.data.next, 'id');

                    $('title').html(newsTitle);
                    $('meta[name="keywords"]').attr('content', json.data.list.article_keywords);
                    $('meta[name="description"]').attr('content', json.data.list.article_excerpt);
                } else {
                    layer.msg("服务器请求失败", { time: 2000 });
                }

            },
            error: function() {
                layer.msg("服务器请求失败", { time: 2000 });
            },
            complete: function() {
                layer.close(index);
            }
        })
    },
    // 阻止默认页面弹起影响触摸位置
    preventInput: function() {
        $("input").blur(function() {
            setTimeout(function() {
                var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
                window.scrollTo(0, Math.max(scrollHeight - 1, 0));
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
            }, 100);
        });
    },
    pageShow: function() {
        $('.page').addClass('pageShow');
    },
    musicPlay: function() {
        music.play();

        // 点击音乐
        $('.h-music-box').click(function(event) {
            if (musicCount == 1) {
                music.play();
                $(this).removeClass('ani-pause'); //去除暂时播放样式
                $(this).addClass('music-on'); //开始播放样式
                musicCount = 0;
            } else {
                $(this).addClass('ani-pause') //添加暂时播放样式
                music.pause();
                musicCount = 1;
            }
        });
    },
    // share: function() {
    //     $.ajax({
    //         url: api + "/wechat/jssdk",
    //         type: "POST",
    //         data: {
    //             uri: window.location.href,
    //         },
    //         success: function(json) {
    //             if (json.code == 200) {
    //                 var ua = navigator.userAgent.toLowerCase();
    //                 if (ua.match(/MicroMessenger/i) == "micromessenger") {
    //                     wx.config(json.data);
    //                     wx.ready(function() {
    //                         wx.updateAppMessageShareData({
    //                             title: '魔卡少女樱：回忆钥匙', // 分享标题
    //                             desc: '收集全世界的可爱', // 分享描述
    //                             link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    //                             imgUrl: 'https://download4.qcplay.com/qcgame-admin/dnX29EuzSenmU1Vt8cDJvCOGHofjdxkHtEs0Lzhm.png', // 分享图标
    //                             success: function() {}
    //                         })

    //                         wx.updateTimelineShareData({
    //                             title: '魔卡少女樱：回忆钥匙 - 收集全世界的可爱', // 分享标题
    //                             link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    //                             imgUrl: 'https://download4.qcplay.com/qcgame-admin/dnX29EuzSenmU1Vt8cDJvCOGHofjdxkHtEs0Lzhm.png', // 分享图标
    //                             success: function() {
    //                                 // 设置成功
    //                             }
    //                         })
    //                     });
    //                     return;
    //                 } else {
    //                     try {
    //                         setShareInfo({
    //                             title: '魔卡少女樱：回忆钥匙', // 分享标题
    //                             summary: '收集全世界的可爱', // 分享内容
    //                             pic: 'https://download4.qcplay.com/qcgame-admin/dnX29EuzSenmU1Vt8cDJvCOGHofjdxkHtEs0Lzhm.png', // 分享图片
    //                             url: window.location.href, // 分享链接
    //                             // 微信权限验证配置信息，若不在微信传播，可忽略
    //                             WXconfig: {
    //                                 swapTitleInWX: true, // 是否标题内容互换（仅朋友圈，因朋友圈内只显示标题）
    //                                 appId: json.data.appId, // 公众号的唯一标识
    //                                 timestamp: json.data.timestamp, // 生成签名的时间戳
    //                                 nonceStr: json.data.nonceStr, // 生成签名的随机串
    //                                 signature: json.data.signature // 签名
    //                             }
    //                         });
    //                     } catch (err) {}
    //                 }
    //             }
    //         }
    //     })
    // },
    share: function() {
        var share_icon =
            "https://download4.qcplay.com/qcgame-admin/dnX29EuzSenmU1Vt8cDJvCOGHofjdxkHtEs0Lzhm.png";
        var share_big_title = "魔卡少女樱：回忆钥匙";
        var share_min_title = "收集全世界的可爱";
        var share_link = window.location.href;
        outside.share(share_icon, share_big_title, share_min_title, share_link);
    },
    setVideo: function() {
        document.getElementById("bg").addEventListener(
            "touchmove",
            function(e) {
                e.preventDefault();
            },
            false
        );
        let canvas = document.getElementById("myCanvas");
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
        let url = "https://download4.qcplay.com/xianjian/web/webvideo.ts";
        let player = new window.$JSMpeg.Player(url, {
            canvas: canvas,
            loop: true,
            autoplay: true,
            chunkSize: 1024 * 1024,
            videoBufferSize: 1024 * 1024,
            //   回调可参考 https://juejin.cn/post/7057406701565116452
            onSourceCompleted: () => {
                // this.playBegin = true;
            },
            onPlay: () => {
                this.playBegin = true;
            },
        });
        player.play();
        // 页面切换请使用 destroy()销毁播放器
    },
    // 阿里云埋点
    countNum: function(data) {
        setTimeout(() => {
            try {
                __bl.sum(data);
            } catch (e) {
                console.log(e)
            }
        }, 500);
    }
}